import { firstName } from '../../lib/format';
import { useIntake } from '../IntakeContext';

const STAGES = [
  { n: 1, title: 'Plan · You are here', body: 'Tell us how your firm works, meet us for a Discovery Session, sign the agreement and approve your migration plan.', current: true },
  { n: 2, title: 'Prepare', body: 'We bring a copy of your firm into the portal from your exports. You look around, check your clients and work, and we pick your launch day together.' },
  { n: 3, title: 'Launch', body: 'Guided training for your team, hands-on help getting your firm set up, and your latest data brought over on launch day.' },
  { n: 4, title: 'Succeed', body: 'We’re with you as you configure the portal and settle in, and here whenever your team needs us.' },
];

export function Welcome() {
  const { answers } = useIntake();
  return (
    <div className="flex flex-col gap-6">
      <div className="flex flex-col gap-2.5">
        <span className="eyebrow">Welcome, {firstName(answers.contact?.name)}</span>
        <h1 className="m-0 text-[26px] font-bold leading-[1.2] tracking-[-0.02em] sm:text-[30px]" tabIndex={-1} data-step-heading style={{ outline: "none" }}>Let’s plan your firm’s move to Upstream Portal</h1>
        <p className="m-0 max-w-[680px] text-base leading-[1.55] text-ink-2">Tell us how your firm runs today. We read your answers before your Discovery Session, so you don’t have to explain anything twice. There’s nothing to upload yet. We’ll ask for files once we know what’s moving.</p>
      </div>
      <div className="grid grid-cols-[repeat(auto-fit,minmax(200px,1fr))] gap-3">
        {[
          ['About 10 minutes', 'Mostly picking from lists. No files or exports needed.'],
          ['Save and come back', 'Your answers save as you go. Your link works for 30 days.'],
          ['Nothing changes yet', 'Your current systems keep running until you approve the plan.'],
        ].map(([t, b]) => (
          <div key={t} className="flex flex-col gap-1 rounded-card border border-line bg-white px-5 py-[18px]">
            <div className="font-semibold">{t}</div>
            <div className="text-sm text-muted">{b}</div>
          </div>
        ))}
      </div>
      <div className="rounded-card border border-line bg-white px-5 py-[18px]">
        <h2 className="mb-2.5 mt-0 text-base font-semibold">Helpful to have nearby</h2>
        <ul className="m-0 flex list-disc flex-col gap-1 pl-5 text-ink-2 marker:text-muted">
          <li>The software and apps your firm uses day to day</li>
          <li>A rough count of your active clients and open returns</li>
          <li>Any spreadsheets or paper lists your firm relies on</li>
        </ul>
      </div>
      <div>
        <h2 className="section-label mb-3 mt-0">How your move works</h2>
        <div className="grid grid-cols-[repeat(auto-fit,minmax(180px,1fr))] gap-2.5">
          {STAGES.map((s) => (
            <div key={s.n} className={s.current ? 'rounded-card border-[1.5px] border-brand bg-white p-4' : 'rounded-card border border-line bg-white p-4'}>
              <div className={`text-xs font-bold uppercase tracking-[0.06em] ${s.current ? 'text-brand' : 'text-muted'}`}>{s.n} · {s.title}</div>
              <div className="mt-1.5 text-sm text-ink-2">{s.body}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
